import { useRecoilValue } from "recoil";
import { FormStatusBase } from "../../../../components";
import { addMeterState } from "../atoms/atoms";

// const FormStatus: React.FC = () => {
export default function FormStatus() {
  const state = useRecoilValue(addMeterState);
  return <FormStatusBase state={state} />;
}

// export default FormStatus;
